<template>
	<div v-if="!loading">
		<div v-if="sessionId && redirectResult ">
			<v-row>
				<v-col>
					<adyen-success-card v-if="succesfulPayment" />
					<adyen-failure-card v-else />
				</v-col>
			</v-row>
		</div>
		<v-row v-if="!succesfulPayment">
			<v-col>
				<v-card>
					<v-card-title>
						<translate>Choose your desired payment method</translate>
					</v-card-title>
					<v-card-text>
						<div
							id="card-container"
						/>
					</v-card-text>
					<v-card-actions>
						<v-row align="center">
							<v-spacer />
							<v-col cols="auto  pl-0 pr-1">
								<v-icon
									color="primary"
									size="small"
									icon="$lock"
								/>
							</v-col>
							<v-col cols="auto pl-0 pr-1">
								<translate
									class="text-grey mb-2"
								>
									Your data is safe
								</translate>
							</v-col>
							<v-col cols="auto  pl-0 pr-2">
								<v-btn
									v-if="checkoutComponent"
									color="primary"
									size="small"
									@click="checkoutComponent.submit()"
								>
									<translate>Complete Payment</translate>
								</v-btn>
							</v-col>
						</v-row>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import {
	default as adyenCheckout,
} from '@adyen/adyen-web';
import axios from 'axios';
import Configuration from '../../mixins/Configuration';
import AdyenFailureCard from './AdyenFailureCard.vue';
import {
	isProduction,
} from '../../services/domain-service';

export default {
	name: 'AdyenPayment',
	components: {
		AdyenFailureCard
	},
	mixins: [Configuration, ],
	props: {
		token: {
			required: true,
			type: String,
		},
		invoiceId: {
			required: true,
			type: Number,
		},
		sessionId: {
			required: true,
			type: String
		},
		redirectResult: {
			required: true,
			type: String
		}
	},

	data () {
		return {
			loading: true,
			checkout: null,
			succesfulPayment: false,
			checkoutComponent: null,
			configuration: {
				environment: isProduction() ? 'live' : 'test', // Messing with it on live will just result in non-rendered component.
				showPayButton: false,
				clientKey: '', // Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
				analytics: {
					enabled: true // Set to false to not send analytics data to Adyen.
				},
				session: {
					id: '', // Unique identifier for the payment session.
					sessionData: '' // The payment session data.
				},

				onPaymentCompleted: (result) => {
					if (result.resultCode === 'Authorised') {
						this.succesfulPayment = true;
					} else {
						this.getSessionData();
					}
					this.loading = false;
				},
				onError: (error) => {
					window.captureException(error);
					this.getSessionData();
					this.loading = false;
				},
			}
		};
	},

	async created () {
		await this.stget('adyen_client_key').then((configVariable) => {
			this.configuration.clientKey = configVariable;
		});
		if (this.sessionId && this.redirectResult) {
			await this.handleRedirect();
		} else {
			await this.getSessionData();
			this.loading = false;
		}
	},

	methods: {
		/**
		 * Handle a redirect session
		 */
		async handleRedirect () {
			this.configuration.session.id = this.sessionId;
			this.checkout = await adyenCheckout(this.configuration);
			await this.checkout.submitDetails({
				details: {
					redirectResult: this.redirectResult
				}
			});
		},

		/**
		 * Get session data and mount the checkout component based on the data
		 */
		async getSessionData () {
			axios.get(`/api/v1/adyen?token=${this.token}&invoice_id=${this.invoiceId}`)
				.then(async ({
					data
				}) => {
					this.configuration.session = data;
					this.checkout = await adyenCheckout(this.configuration);

					this.checkoutComponent = this.checkout.create('ideal').mount('#card-container');
				});
		},
	}
};
</script>

<style scoped>

</style>
